var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'active': _vm.currentTab.text === _vm.text, 'tab': true, 'disabled': _vm.disabled},on:{"click":function($event){return _vm.setCurrentTab(_vm.text, _vm.value)}}},[_vm._v(_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }